import { RootState } from "../index"

export function getProjectCases(state: RootState) {
  return state.project.cases
}

export function getDimensions(state: RootState) {
  return state.project.dims
}

export function getActiveUnitSet(state: RootState) {
  return state.project.unitSet
}

export function getProjectPropertySets(state: RootState) {
  return state.project.propertySets
}

export function getProjectSimulations(state: RootState) {
  return state.project.simulations
}